module.exports = __webpack_public_path__ + "static/media/Paloma Ave, Burlingame, CA2.dc11ff73.jpg";